import { Dispatch } from "redux";
import { AdminAccessService } from "../../Services/adminService";
import {
  FETCH_ADMIN_ACCESS_FAILURE,
  FETCH_ADMIN_ACCESS_REQUEST,
  FETCH_ADMIN_ACCESS_SUCCESS,
} from "./AdminAccessTypes";
import { buildAppError } from "../../Utils/AppError";

export const fetchAdminAccess = (token: string) => {
  return async (dispatch: Dispatch) => {
    if (!token) return;
    dispatch({ type: FETCH_ADMIN_ACCESS_REQUEST });
    try {
      const response = await AdminAccessService.checkAccess(token);
      dispatch({ type: FETCH_ADMIN_ACCESS_SUCCESS, payload: response.has_access });
    } catch (error: any) {
      const appError = buildAppError(error, "");
      dispatch({ type: FETCH_ADMIN_ACCESS_FAILURE, payload: appError.message });
    }
  };
};
